<template>
  <div class="organisation">
    <ContainerLayout :isOverview="isOverview">
      <template v-slot:contentPart>
        <component :is="dynamicComponent.content"/>
      </template>
      <template v-slot:contextActionPanel>
        <ActionPanel :selectedView="selectedView" :actions="actionsForPanel">
        </ActionPanel>
      </template>
      <template v-slot:contextPart>
        <component :is="dynamicComponent.context"/>
      </template>
      <template v-slot:contextFooter>
        <ContextFooterRM :selectedView="selectedView"/>
      </template>
    </ContainerLayout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { organizationService } from '@/_services'
import ContainerLayout from '@/components/wrld/generic/ContainerLayout'
import ActionPanel from '@/components/wrld/generic/ActionPanel'
import ContextFooterRM from '@/components/wrld/generic/ContextFooterRM'

import OrganizationsOverviewContent from '@/components/organizations/OrganizationsOverviewContent'
import OrganizationsOverviewContext from '@/components/organizations/OrganizationsOverviewContext'
import OrganizationsDetailContent from '@/components/organizations/OrganizationsDetailContent'
import OrganizationsDetailContext from '@/components/organizations/OrganizationsDetailContext'
import FleetOverviewContent from '@/components/organizations/fleet/FleetOverviewContent'
import FleetOverviewContext from '@/components/organizations/fleet/FleetOverviewContext'
import LocationsOverviewContent from '@/components/organizations/locations/LocationsOverviewContent'
import LocationsOverviewContext from '@/components/organizations/locations/LocationsOverviewContext'
import UsersOverviewContent from '@/components/organizations/users/UsersOverviewContent'
import UsersOverviewContext from '@/components/organizations/users/UsersOverviewContext'
import ContactsOverviewContent from '@/components/organizations/users/ContactsOverviewContent'
import ContactsOverviewContext from '@/components/organizations/users/ContactsOverviewContext'
import VehicleClassOverviewContent from '@/components/organizations/fleet/VehicleClassOverviewContent'
import VehicleClassOverviewContext from '@/components/organizations/fleet/VehicleClassOverviewContext'

export default {
  name: 'Organizations',
  components: {
    ContainerLayout,
    ActionPanel,
    ContextFooterRM,
    OrganizationsOverviewContent,
    OrganizationsOverviewContext,
    OrganizationsDetailContent,
    OrganizationsDetailContext,
    FleetOverviewContent,
    FleetOverviewContext,
    VehicleClassOverviewContent,
    VehicleClassOverviewContext,
    LocationsOverviewContent,
    LocationsOverviewContext,
    UsersOverviewContent,
    UsersOverviewContext,
    ContactsOverviewContent,
    ContactsOverviewContext
  },
  props: {
    selectedView: String
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getSelectedResourceID',
      'getContentLastUrl',
      'getLoggedInUserOrganizationID'
    ]),
    isOverview () {
      return this.selectedView === 'overview'
    },
    isMyOrganization () {
      return this.getSelectedResourceID.objectID === this.getLoggedInUserOrganizationID
    },
    actionsForPanel () {
      let panelActions = []
      let show = {
        back: false,
        detail: false,
        fleet: false,
        locations: false,
        users: false
      }

      switch (this.selectedView) {
        case 'overview':
          if (this.getSelectedResourceID.objectID !== null) {
            // show.detail = true
            show.fleet = true
            show.locations = true
            show.users = true
          }
          break
        case 'detail':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        case 'fleet':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        case 'vehicleClasses':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        case 'locations':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        case 'users':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        case 'contacts':
          show.back = true
          show.fleet = true
          show.locations = true
          show.users = true
          break
        default: // default is overview
          if (this.getSelectedResourceID.objectID !== null) {
            // show.detail = true
            show.fleet = true
            show.locations = true
            show.users = true
          }
          break
      }
      if (show.back === true) {
        panelActions.push({
          icon: 'fas fa-arrow-circle-left',
          name: this.$i18n.t('buttons.back'),
          callback: this.goToOverview
        })
      }
      if (show.detail === true) {
        panelActions.push({
          key: 'detail',
          icon: 'fas fa-info-circle',
          name: this.$i18n.t('organizations.organization_detail'),
          callback: this.goToDetail
        })
      }
      if (show.fleet === true) {
        panelActions.push({
          key: this.isMyOrganization ? 'fleet' : 'vehicleClasses',
          icon: 'fas fa-truck',
          name: this.$i18n.t('fleet.fleet'),
          callback: this.goToFleet.bind(null, this.isMyOrganization)
        })
      }
      if (show.locations === true) {
        panelActions.push({
          key: 'locations',
          icon: 'fas fa-map-marked-alt',
          name: this.$i18n.t('menu.locations'),
          callback: this.goToLocations
        })
      }
      if (show.users === true) {
        panelActions.push({
          key: this.isMyOrganization ? 'users' : 'contacts',
          icon: 'fas fa-users',
          name: this.isMyOrganization ? this.$i18n.t('organizations.users') : this.$i18n.tc('organizations.contacts', 3),
          callback: this.goToUsers.bind(null, this.isMyOrganization)
        })
      }
      return panelActions
    },
    // TODO: improve performence - add dynamic loading of components
    dynamicComponent () {
      switch (this.selectedView) {
        case 'overview':
          return {
            content: 'OrganizationsOverviewContent',
            context: 'OrganizationsOverviewContext'
          }
        case 'detail':
          return {
            content: 'OrganizationsDetailContent',
            context: 'OrganizationsOverviewContext'
          }
        case 'fleet':
          return {
            content: 'FleetOverviewContent',
            context: 'FleetOverviewContext'
          }
        case 'vehicleClasses':
          return {
            content: 'VehicleClassOverviewContent',
            context: 'VehicleClassOverviewContext'
          }
        case 'locations':
          return {
            content: 'LocationsOverviewContent',
            context: 'LocationsOverviewContext'
          }
        case 'users':
          return {
            content: 'UsersOverviewContent',
            context: 'UsersOverviewContext'
          }
        case 'contacts':
          return {
            content: 'ContactsOverviewContent',
            context: 'ContactsOverviewContext'
          }
        default: // default is overview
          return {
            content: 'OrganizationsOverviewContent',
            context: 'OrganizationsOverviewContext'
          }
      }
    }
  },
  methods: {
    ...mapActions({
      clearResourceStore: 'clearResourceStore',
      selectResourceSecond: 'selectResourceSecond',
      updateResource: 'updateResource',
      setContentLastUrl: 'setContentLastUrl',
      unselectResource: 'unselectResource',
      paginationResetState: 'pagination/setResetState',
      queryResetState: 'queryFilters/setResetState',
      refinementListResetState: 'refinementListFilters/setResetState'
    }),
    goToDetail (resourceID) {
      if (this.getSelectedResourceID.objectID !== null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        this.$router.push({ name: 'OrganizationsDetail', params: { organizationID: this.getSelectedResource.objectID } })
        this.selectResourceSecond(null)
      }
    },
    goToFleet (isMyOrganization) {
      if (this.getSelectedResourceID.objectID !== null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        if (isMyOrganization) {
          this.$router.push({ name: 'OrganizationsFleet', params: { organizationID: this.getSelectedResource.objectID } })
        } else {
          this.$router.push({ name: 'OrganizationsVehicleClasses', params: { organizationID: this.getSelectedResource.objectID } })
        }
        this.selectResourceSecond(null)
      }
    },
    goToLocations (resourceID) {
      if (this.getSelectedResourceID.objectID !== null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        this.$router.push({ name: 'OrganizationsLocations', params: { organizationID: this.getSelectedResource.objectID } })
        this.selectResourceSecond(null)
      }
    },
    goToUsers (isMyOrganization) {
      if (this.getSelectedResourceID.objectID !== null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        if (isMyOrganization) {
          this.$router.push({ name: 'OrganizationsUsers', params: { organizationID: this.getSelectedResource.objectID } })
        } else {
          this.$router.push({ name: 'OrganizationsContacts', params: { organizationID: this.getSelectedResource.objectID } })
        }
        this.selectResourceSecond(null)
      }
    },
    goToOverview (resourceID) {
      // this.$router.push({ name: 'OrganizationsOverview' })
      const url = this.getContentLastUrl
      if (url !== null) {
        this.$router.push({ path: url })
      } else {
        this.$router.push({ name: 'OrganizationsOverview' })
      }
      // this.unselectResource()
      this.selectResourceSecond(null)
    }
  },
  async created () {
    this.clearResourceStore()
    if (this.$route.params.organizationID !== undefined) {
      const organization = await organizationService.getOrganization({ organizationID: this.$route.params.organizationID })
      this.updateResource({ resource: { ...organization, objectID: organization.id } })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.indexOf('organizations') < 0) {
      this.paginationResetState()
      this.queryResetState()
      this.refinementListResetState()
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.organisation {
  background-color: #FAFAFA;
}
</style>
